import { render, staticRenderFns } from "./RestoreModal.vue?vue&type=template&id=c2a44198&scoped=true"
import script from "./RestoreModal.vue?vue&type=script&lang=ts"
export * from "./RestoreModal.vue?vue&type=script&lang=ts"
import style0 from "./RestoreModal.vue?vue&type=style&index=0&id=c2a44198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a44198",
  null
  
)

export default component.exports